<template>
  <PmSidebarProjectPure
    v-if="stockTypeService"
    :id="stockTypeService.id"
    :title="stockTypeService.caption"
    :alerts-visible="store.state.view.currentView.showMissingResourcesWarning"
    :pill="stockTypeService.number"
    :update-group-visible="false"
    :jump-visible="true"
    :type="CALENDAR_ITEM_TYPE.STOCK_TYPE_SERVICE"
    :is-highlighted="isHighlighted"
    @show-details="showDetails"
    @jump="jumpToStockTypeServiceInCalendar"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

import { EVENT } from '@/constants/events'
import { CALENDAR_ITEM_TYPE, DATA_MODAL_TYPE } from '@/constants/persoplan'
import { useCachedQuery } from '@/composition/useCachedQuery'
import { useJumpTargetRegistry } from '@/composition/useJumpTargetRegistry'
import EventHub from '@/eventHub'

import PmSidebarProjectPure from '@/components/persoplan/PmSidebarProject/PmSidebarProjectPure.vue'

import { SidebarStockTypeServiceDocument } from '../../../../generated/graphql'

export interface Props {
  id: number
}

const props = defineProps<Props>()

const store = useStore()
const jumpTargetRegistry = useJumpTargetRegistry()

const stockTypeServiceQuery = useCachedQuery(
  SidebarStockTypeServiceDocument,
  () => ({
    id: props.id,
  })
)

const stockTypeService = computed(
  () => stockTypeServiceQuery.result.value?.stockTypeService
)

function showDetails() {
  EventHub.$emit(EVENT.DATA_MODAL_SHOW, {
    type: DATA_MODAL_TYPE.STOCK_TYPE_SERVICE,
    id: props.id,
  })
}

function jumpToStockTypeServiceInCalendar() {
  const jumpTarget = {
    type: CALENDAR_ITEM_TYPE.STOCK_TYPE_SERVICE,
    id: props.id,
  } as const

  if (!jumpTargetRegistry.isAvailable(jumpTarget)) {
    throw new Error('jumpTarget is not available')
  }

  jumpTargetRegistry.jumpTo(jumpTarget)
  store.commit('persoplan/clearHighlightedItems')
  isHighlighted.value = true
}

const isHighlighted = computed({
  get: function () {
    return store.getters['persoplan/isItemHighlighted']({
      id: props.id,
      type: CALENDAR_ITEM_TYPE.STOCK_TYPE_SERVICE,
    })
  },
  set: function (value) {
    if (value === true) {
      store.commit('persoplan/addToHighlightedItems', {
        id: props.id,
        type: CALENDAR_ITEM_TYPE.STOCK_TYPE_SERVICE,
      })
    } else {
      store.commit('persoplan/removeFromHighlightedItems', {
        id: props.id,
        type: CALENDAR_ITEM_TYPE.STOCK_TYPE_SERVICE,
      })
    }
  },
})
</script>
